import React, { Component } from 'react';
import Helmet from "react-helmet";

import Logout from '../../components/login/logout';

const LogoutPage = () => (
	<div className="logout-delayed-index">
		<Helmet>
			<title>ИРМ - Выход</title>
		</Helmet>
		<Logout />
	</div> 
)

export default LogoutPage;


// WEBPACK FOOTER //
// ./src/routes/login/logout.jsx